module.exports = __webpack_public_path__ + "static/media/LunaticSuperstar-8KgB.b1e22dbc.otf";